import { snakeToTitleCase } from '../common-methods';

const MAX_CONTRACT_LINK_LENGTH = 40;
const TRUNCATE_LENGTH = 20;

export function formatChanges(changes) {
  if (!changes) return 'No Change';

  if (Array.isArray(changes) && changes.length > 0 && typeof changes[0] === 'object') {
    return changes
      .map((change) => {
        if (change.field === 'Tier Rates') {
          return `${change.field}: ${change.newValue ?? 'N/A'}`;
        }
        let oldValue = change.oldValue ?? 'N/A';
        let newValue = change.newValue ?? 'N/A';

        if (change.field === 'rentType' || change.field === 'paymentType') {
          oldValue = snakeToTitleCase(oldValue);
          newValue = snakeToTitleCase(newValue);
        }

        if (change.field.toLowerCase() === 'contractlink') {
          if (typeof oldValue === 'string' && oldValue.length > MAX_CONTRACT_LINK_LENGTH) {
            const shortOldValue =
              oldValue.substring(0, TRUNCATE_LENGTH) + '...' + (oldValue.includes('sharepoint') ? '(SharePoint)' : '');
            oldValue = `URL_START${oldValue}URL_DISPLAY${shortOldValue}URL_END`;
          }
          if (typeof newValue === 'string' && newValue.length > MAX_CONTRACT_LINK_LENGTH) {
            const shortNewValue =
              newValue.substring(0, TRUNCATE_LENGTH) + '...' + (newValue.includes('sharepoint') ? '(SharePoint)' : '');
            newValue = `URL_START${newValue}URL_DISPLAY${shortNewValue}URL_END`;
          }
        }

        return `${change.field} : ${oldValue} --> ${newValue}`;
      })
      .join(',\n');
  }

  if (Array.isArray(changes)) {
    return changes
      .map((change) => {
        if (typeof change !== 'string') return '';
        return change
          .replace(/-->/g, ' → ')
          .replace(/(\w+)\s*:/g, '$1:')
          .replace(/(\w+):/g, '$1: ')
          .replace(/\$(\d)/g, '$ $1')
          .replace(/\$\s\s+/g, '$ ')
          .replace(/(\d+)\.(\d+)%/g, '$1.$2 %')
          .replace(/N\/A(\s*)→/g, 'N/A →')
          .replace(/(\S)(\s*→\s*)(\S)/g, '$1 → $3')
          .replace(/(Revenue|Sales)(\s*)(up to)(\s*)(\$\d+)(\s*)(=)(\s*)(\d+)(%)/gi, '$1 $3 $5 = $9 $10');
      })
      .join('\n');
  }

  return 'New Lease Created';
}
